import { PushCampaignType as PushCampaignTypeEnum } from '../constants/push-campaign.enum'

export interface ValidationError {
  [key: string]: string
}

const HAS_LETTER = /[\p{L}]/u

export const validateNotAllSpecialChars = (value: string): boolean => {
  // Allow special characters, but must contain at least one letter.
  // This intentionally treats "only numbers" as invalid.
  // - Treat whitespace-only as invalid (will be caught by required trim checks too).
  const v = (value ?? '').trim()
  if (!v) return true
  return HAS_LETTER.test(v)
}

export const validateUrl = (url: string): boolean => {
  if (!url) return true
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

export interface CampaignForm {
  campaign_type: string
  title: string
  notification_title: string
  notification_content: string
  link_type: string
  link: string
  reward_type: string
  reward_amount: string
  target_audience: string
  audience_conditions: {
    type: string
    child: unknown[]
  }
  type: string
  scheduled_date: string
}

export const validateCampaignForm = (
  form: CampaignForm,
): ValidationError => {
  const e: ValidationError = {}

  if (!form.title.trim()) {
    e.title = 'Tiêu đề chiến dịch không được bỏ trống'
  } else if (!validateNotAllSpecialChars(form.title)) {
    e.title = 'Tiêu đề chiến dịch không được chỉ gồm ký tự đặc biệt'
  }

  if (!form.notification_title.trim()) {
    e.notification_title = 'Tiêu đề thông báo không được bỏ trống'
  } else if (!validateNotAllSpecialChars(form.notification_title)) {
    e.notification_title = 'Tiêu đề thông báo không được chỉ gồm ký tự đặc biệt'
  }

  if (!form.notification_content.trim()) {
    e.notification_content = 'Nội dung thông báo không được bỏ trống'
  } else if (!validateNotAllSpecialChars(form.notification_content)) {
    e.notification_content = 'Nội dung thông báo không được chỉ gồm ký tự đặc biệt'
  }

  if (form.campaign_type === PushCampaignTypeEnum.NotificationLink) {
    if (!form.link.trim()) {
      e.link = 'Liên kết không được bỏ trống'
    } else if (!validateUrl(form.link.trim())) {
      e.link = 'Liên kết không hợp lệ (phải có http:// hoặc https://)'
    }
  }

  if (form.campaign_type === PushCampaignTypeEnum.NotificationReward) {
    const amount = Number(form.reward_amount)
    if (!form.reward_amount.trim()) {
      e.reward_amount = 'Số điểm thưởng không được bỏ trống'
    } else if (isNaN(amount) || amount < 0) {
      e.reward_amount = 'Số điểm thưởng phải là số không âm'
    }
  }

  if (form.type === 'future') {
    if (!form.scheduled_date) {
      e.scheduled_date = 'Ngày gửi không được bỏ trống'
    }
  }

  if (form.target_audience === 'specific') {
    const conditions = form.audience_conditions
    if (!conditions.child || conditions.child.length === 0) {
      e.audience_conditions = 'Đối tượng áp dụng không được bỏ trống'
    }
  }

  return e
}
